import { render, staticRenderFns } from "./DepositFunds.vue?vue&type=template&id=2c725fc2&scoped=true"
import script from "./DepositFunds.vue?vue&type=script&lang=js"
export * from "./DepositFunds.vue?vue&type=script&lang=js"
import style0 from "./DepositFunds.vue?vue&type=style&index=0&id=2c725fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c725fc2",
  null
  
)

export default component.exports